import useInfiniteTransactionScroll from 'utils/hooks/useInfiniteTransactionScroll';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import InfiniteScroll from 'components/shared/infiniteScroll/presentational/InfiniteScroll';
import Transactions from '../presentational/Transactions';
import useTransactions from '../hooks/useTransactions';
import useTranslate from 'lib/languages/useTranslate';
import useAccountMigrationCheck from 'lib/hooks/useAccountMigrationCheck';
import Button from 'components/shared/generic/button/presentational/Button';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import { useGetFeesQuery } from 'lib/services/fees';

const TransactionsContainer = () => {
    const translate = useTranslate('transactionsList');
    const token = localStorage.getItem('accessToken') as string;
    useGetFeesQuery();

    const {
        isAccountMigrated,
        selectedAccountCardProvider,
        showPreviousAccountTransactions,
        selectedAccountBankNumber,
        toggleShowPreviousTransactions,
    } = useAccountMigrationCheck(token);

    const {
        loadMoreTransaction,
        transactions,
        isFetchingTransactions,
        hasNextPage,
        error,
    } = useTransactions(isAccountMigrated ? selectedAccountCardProvider : null);

    const ref = useInfiniteTransactionScroll(
        loadMoreTransaction,
        isFetchingTransactions,
    );

    const buttonTransactionsProps = {
        text: showPreviousAccountTransactions
            ? translate('buttonTransactionHideText')
            : translate('buttonTransactionShowText'),
        className: 'transaction-toggle-button',
    };

    return (
        <PageContainer className="transactions-container">
            <SectionTitle title={translate('title')} backRoute={'/'} />
            {isAccountMigrated && (
                <>
                    <Button
                        className={buttonTransactionsProps.className}
                        onClick={toggleShowPreviousTransactions}
                    >
                        {buttonTransactionsProps.text}
                    </Button>
                    {showPreviousAccountTransactions && (
                        <>
                            <Typography className="transaction-show-text">
                                {translate('showingTransactionsFrom')}
                            </Typography>
                            <Typography className="transaction-show-text">
                                {selectedAccountBankNumber}
                            </Typography>
                        </>
                    )}
                </>
            )}
            <DataCheck
                data={transactions}
                error={(error as any)?.data?.message}
                noDataMessage={translate('transactionsList')}
            >
                <InfiniteScroll
                    className="transactions-scroll-container"
                    ref={ref}
                    last={hasNextPage}
                >
                    <Transactions data={transactions} />
                </InfiniteScroll>
            </DataCheck>
        </PageContainer>
    );
};

export default TransactionsContainer;
